import { FiMoreVertical, FiTrash2 } from 'react-icons/fi'
import useComponentVisible from '../../../hooks/useComponentVisible';
import moment from 'moment';
import { NOTIFICATION_TYPES, ROLES } from '../../../constants';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/app';
import { getUser } from '../../../store/slices/auth-slice';

function NotificationCard({ notification, removeNotification }: { notification: any, removeNotification: (id: string) => void }) {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const user = useAppSelector(getUser)
    let link = '';
    if (notification?.type === NOTIFICATION_TYPES.ENDORSEMENT_REQUEST) {
        link = `/training/request-signatures/approve/${notification?.reference}`;
        if (user?.role === ROLES.STUDENT) {
            link = `/training/request-signatures`;
        }
    } else if (notification?.type === NOTIFICATION_TYPES.INVITATION_REQUEST) {
        link = `/training/invitations`;
    } else if (notification?.type === NOTIFICATION_TYPES.FLIGHT_REQUEST) {
        link = `/training/request-signatures/approve/${notification?.reference}`;
        if (user?.role === ROLES.STUDENT) {
            link = `/training/request-signatures`;
        }
    }
    return (
        <div className='notification_card'>
            <Link to={link}>
                <div className="left">
                    <div className="image"></div>
                    <div className="content">
                        <div className="name">{notification?.createdBy?.firstname} {notification?.createdBy?.lastname}</div>
                        <div className="text">
                            {notification?.type === NOTIFICATION_TYPES.ENDORSEMENT_REQUEST ? "Endorsement Signature Request" : notification?.type === NOTIFICATION_TYPES.INVITATION_REQUEST ? "Invitation Request" : notification?.type === NOTIFICATION_TYPES.FLIGHT_REQUEST ? "Flight Signature Request" : null
                            }</div>
                        <div className="date">{(() => { const t = moment(notification.createdAt); return t.isSame(moment(), 'day') ? `Today at ${t.format("h:mm A")}` : t.isSame(moment().subtract(1, 'days'), 'day') ? `Yesterday at ${t.format("h:mm A")}` : t.format("dddd [at] h:mm A") })()}</div>
                    </div>
                </div>
            </Link>
            <span className={`notification_action ${isComponentVisible ? 'active' : ''}`} ref={ref} onClick={() => setIsComponentVisible(true)}>
                <FiMoreVertical />
                {isComponentVisible && <div className={`action_dropdown ${isComponentVisible ? 'active' : ''}`} onClick={() => removeNotification(notification?._id as string)}>
                    <span><FiTrash2 /></span>
                    <span>Delete</span>
                </div>}
            </span>
        </div>
    )
}

export default NotificationCard